import React from 'react';
import { motion } from 'framer-motion';
import { Home, Key, HardHat, Sparkles, Building2, BedDouble } from 'lucide-react';
const services = [{
  title: 'Move-Out Cleaning',
  description: 'Leave your old place spotless to guarantee your deposit return and peace of mind.',
  icon: Home
}, {
  title: 'Move-In Cleaning',
  description: 'Start fresh in a perfectly sanitized, reset space before you unpack a single box.',
  icon: Key
}, {
  title: 'Post-Construction Cleaning',
  description: 'Heavy-duty dust removal to reveal the true beauty of your new build.',
  icon: HardHat
}, {
  title: 'Deep Cleaning',
  description: 'Intensive top-to-bottom scrubbing that tackles neglected areas and built-up grime.',
  icon: Sparkles
}, {
  title: 'Commercial Cleaning',
  description: 'Professional maintenance for offices and retail spaces to impress clients and staff.',
  icon: Building2
}, {
  title: 'Airbnb Turnover',
  description: 'Fast, reliable resets between guests to keep your ratings high and reviews glowing.',
  icon: BedDouble
}];
export function Services() {
  return <section id="services" className="py-32 bg-paper relative" data-id="element-259">
      <div className="container mx-auto px-8 lg:px-12" data-id="element-260">
        <div className="mb-20 md:mb-32 flex flex-col md:flex-row md:items-end justify-between gap-8" data-id="element-261">
          <div className="max-w-2xl" data-id="element-262">
            <div className="flex items-center gap-4 mb-6" data-id="element-263">
              <div className="w-8 h-[1px] bg-lime" data-id="element-264"></div>
              <span className="text-ink/50 font-body text-xs uppercase tracking-[0.3em]" data-id="element-265">
                Our Expertise
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl text-ink font-light leading-tight" data-id="element-266">
              Elevated cleaning services for <br className="hidden md:block" data-id="element-267" />
              <span className="font-medium" data-id="element-268">premium properties.</span>
            </h2>
            <p className="text-ink/60 font-light text-sm leading-relaxed mt-6 max-w-xl" data-id="element-269">
              From move-out cleaning and deep cleaning to post-construction
              cleaning and commercial cleaning, we serve homeowners, Realtors
              and property managers across Orlando, Kissimmee, Broward &
              surrounding areas in Florida.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16" data-id="element-270">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={service.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1,
            ease: 'easeOut'
          }} className="group" data-id="element-271">
                <div className="mb-8 text-ink/40 group-hover:text-lime transition-colors duration-500" data-id="element-272">
                  <Icon size={32} strokeWidth={1} data-id="element-273" />
                </div>

                <h3 className="text-xl text-ink font-medium mb-4 tracking-wide" data-id="element-274">
                  {service.title}
                </h3>
                <p className="text-ink/60 font-light leading-relaxed text-sm" data-id="element-275">
                  {service.description}
                </p>
                <div className="w-0 h-[1px] bg-ink mt-8 group-hover:w-full transition-all duration-700 ease-in-out" data-id="element-276"></div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}